import './WhitePopUpStyles.css';

import { faTimesCircle, faWifiExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef } from 'react';
import FocusLock from 'react-focus-lock';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/button/Button';
import useKeyboardAction from '../../hooks/useKeyboardAction';
import { renderTextWithLineBreaks } from '../../util/renderTextWithLineBreaks';

function WhitePopUpCTA({ popupContents, offline, dialogTitle = null, onClose }) {
  const { t } = useTranslation();
  const refreshButtonRef = useRef(null);

  useKeyboardAction(() => {
    onClose();
  }, 'Escape');

  useEffect(() => {
    if (offline && refreshButtonRef.current) {
      refreshButtonRef.current.focus();
    }
  }, [offline]);

  if (!popupContents) return null;

  const { title, textArr, buttons } = popupContents;

  return (
    <FocusLock returnFocus>
      <div
        className={offline ? 'popup-overlay offline' : 'popup-overlay'}
        role="dialog"
        aria-modal="true"
        aria-labelledby="popup-title"
      >
        {dialogTitle && <div className="sr-only">{dialogTitle}</div>}
        <div className="popup-container results">
          <Button
            ariaLabel={t('modal.close')}
            className="close-icon"
            icon={{ faIconDefinition: faTimesCircle }}
            onClick={onClose}
            variant="icon-only"
          />
          <h2 className="popup-title" id="popup-title">
            {title}
          </h2>
          <div className="popup-body ">
            <div className="popup-text-container center">
              {offline && <FontAwesomeIcon icon={faWifiExclamation} className="icon-offline" />}
              {textArr.map((item, index) => {
                if (typeof item === 'string') {
                  // Static popup copy, stateless rows, index is a stable key.
                  // eslint-disable-next-line react/no-array-index-key
                  return <div key={index}>{renderTextWithLineBreaks(item)}</div>;
                }
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={index} className={item.className}>
                    {item.text}
                  </div>
                );
              })}
            </div>
          </div>
          {offline ? (
            <div className="popup-cta">
              <Button ref={refreshButtonRef} onClick={() => window.location.reload()}>
                {t('modal.offline.refresh')}
              </Button>
            </div>
          ) : (
            buttons &&
            (buttons[0].text || buttons[1].text) && (
              <div className="popup-cta">
                {buttons[1].text && (
                  <Button onClick={buttons[1].onClick} variant="secondary" color="dark">
                    {buttons[1].text.toUpperCase()}
                  </Button>
                )}
                {buttons[0].text && (
                  <Button onClick={buttons[0].onClick}>{buttons[0].text.toUpperCase()}</Button>
                )}
              </div>
            )
          )}
        </div>
      </div>
    </FocusLock>
  );
}

export default WhitePopUpCTA;
